import { afterRenderEffect, ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { InstructionsComponent } from '@r1-compass-library/components';

@Component({
    selector: 'r1-compass-lib-enable-entity',
    imports: [InstructionsComponent, MatSlideToggleModule, ReactiveFormsModule, MatButtonModule],
    template: `
        <form>
            <div class="enable-main-container">
                <div class="enable-instructions-container">
                    <r1-compass-lib-instructions [headerText]="copyHeader()">
                        <ng-content />
                    </r1-compass-lib-instructions>
                </div>
                <div class="enable-fields-container">
                    <div class="form-row-container">
                        <span class="field-row-name">Enable {{ entityType() }}</span>
                        <div class="field-wrapper">
                            <mat-slide-toggle [checked]="currentEnableStatus()" (change)="toggleChange.emit($event)" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-container">
                <button mat-raised-button color="primary" type="button" (click)="save.emit()">Save</button>
            </div>
        </form>
    `,
    styleUrl: './enable-entity.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnableEntityComponent {
    public currentEnableStatus = input.required<boolean | undefined>();
    public entityType = input.required<string>();
    public copyHeader = input.required<string>();

    public save = output<void>();
    public toggleChange = output<MatSlideToggleChange>();

    public initialStatus = signal<boolean | undefined>(undefined);
    public statusChanged = computed<boolean>(() => this.initialStatus() !== this.currentEnableStatus());

    constructor() {
        afterRenderEffect(() => {
            // Set first real value of the status
            const currentEnableStatus = this.currentEnableStatus();
            const initialStatus = this.initialStatus();
            if (currentEnableStatus !== undefined && initialStatus === undefined) {
                this.initialStatus.set(currentEnableStatus);
            }
        });
        // Makes the baseline initial status be what is saved
        this.save.subscribe(() => this.initialStatus.set(this.currentEnableStatus()));
    }
}
